import { Container } from "pixi.js";
import { UpgradeTutorialForTokenTooltip } from "./UpgradeTutorialForTokenTooltip";
import { UpgradeResourcePackage } from "../../resources/UpgradeResourcePackage";
import { Hand } from "by/gamefactory/cityversetycoon/scenes/common/components/Hand";
import gsap from "gsap";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { SoundsResourcePackageWrapper } from "by/gamefactory/cityversetycoon/scenes/common/resources/SoundsResourcePackageWrapper";

export class UpgradeTutorialForToken extends Container {
    private static readonly ANIMATION_TIME = 0.6;
    private static readonly HAND_DEFAULT_POS_X = 535;
    private static readonly HAND_DEFAULT_POS_Y = 1115;
    private static readonly HAND_DEFAULT_ANGLE = 10;
    private static readonly HAND_START_POS_X = 500;
    private static readonly HAND_START_POS_Y = 1850;
    private static readonly HAND_START_ANGLE = -110;

    private readonly upgradeResources: UpgradeResourcePackage;
    private readonly commonResources: CommonResourcesPackage;
    private readonly soundResources: SoundsResourcePackageWrapper;
    private readonly animations: gsap.core.Timeline;

    private tooltip: UpgradeTutorialForTokenTooltip;
    private hand: Hand;

    public constructor(
        upgradeResources: UpgradeResourcePackage,
        commonResources: CommonResourcesPackage,
        soundResources: SoundsResourcePackageWrapper
    ) {
        super();
        this.upgradeResources = upgradeResources;
        this.commonResources = commonResources;
        this.soundResources = soundResources;
        this.animations = new gsap.core.Timeline({ paused: true });
        this.build();
        this.createAnimations();
    }

    private build(): void {
        this.tooltip = new UpgradeTutorialForTokenTooltip(this.upgradeResources);
        this.tooltip.visible = false;
        this.tooltip.pivot.y = this.tooltip.height;
        this.tooltip.pivot.x = this.tooltip.width * 0.85;
        this.tooltip.position.set(709, 1106);
        this.hand = new Hand(this.commonResources);
        this.hand.angle = 3;
        this.hand.scale.set(0.6);
        this.hand.visible = false;
        this.addChild(this.tooltip, this.hand);
    }

    private createAnimations(): void {
        const duration = UpgradeTutorialForToken.ANIMATION_TIME;
        this.animations.fromTo(this.tooltip.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: duration, ease: "back.out(1)" }, "0");
        this.animations.fromTo(this.hand,
            {
                x: UpgradeTutorialForToken.HAND_START_POS_X,
                y: UpgradeTutorialForToken.HAND_START_POS_Y,
                angle: UpgradeTutorialForToken.HAND_START_ANGLE
            },
            {
                x: UpgradeTutorialForToken.HAND_DEFAULT_POS_X,
                y: UpgradeTutorialForToken.HAND_DEFAULT_POS_Y,
                angle: UpgradeTutorialForToken.HAND_DEFAULT_ANGLE,
                duration: duration,
            }, "0");
        this.animations.fromTo(this.hand.scale, { x: 0, y: 0 }, { x: this.hand.scale.x, y: this.hand.scale.y, duration: duration }, "0");
    }

    public async showTutorial(): Promise<void> {
        this.soundResources.assets_sounds_myBuildings_upgrade_info_single_general_in_mp3.play();
        this.soundResources.assets_sounds_hand_movemet_general_mp3.play();
        this.tooltip.visible = true;
        this.hand.visible = true;
        await this.animations.play();
    }

    public async hideTutorial(): Promise<void> {
        await this.animations.reverse();
        this.tooltip.visible = false;
        this.hand.visible = false;
    }
}